import { render, staticRenderFns } from "./FormTermsConditionsQuestionSettings.vue?vue&type=template&id=021a4165"
import script from "./FormTermsConditionsQuestionSettings.vue?vue&type=script&lang=js"
export * from "./FormTermsConditionsQuestionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports